import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faPlus, faUndo } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import CreatableSelect from "react-select/creatable";
import { Redirect, Link } from "react-router-dom";
import apiUrl from "../apiUrlConstant";
import { PopupMessage } from "../utils/utils";
//import Masters from "../masters/Masters";
import * as Yup from "yup";
//import AuthService from "../AuthService";
import { Alert } from "react-bootstrap";

const loginForm = Yup.object().shape({
  email: Yup.string().required("Required"),
});

class UserForgotPassword extends React.Component {
  state = {
    redirect: false,
    showLoader: false,
    errorMessage: "",
    showAlert: false,
    setShow: false,
    popupContent: "",
    messsagePopup: false,
  };

  componentDidMount() { }

  constructor(props) {
    super(props);
  }
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, popupContent: "" });
  };

  render() {
    //console.log(this.props.match,"this.props.match.params.token");

    if (this.state.redirect == true) {
      let url = this.props.match;
      this.state.redirect = false;
      return <Redirect push to="/login" />;
    }
    return (
      <div
        className="parentContainer"
      >
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <Formik
          validationSchema={loginForm}
          initialValues={{}}
          onSubmit={(values, actions, props) => {
            var ths = this;
            // ths.showLoader = true;
            this.setState({ showLoader: true });

            var self = this;

            //console.log(this.props.match.params.token,"this.props.match.params.token")

            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/user/forgot-password`,
              data: values,
            }).then(function (response) {
              if (response.data.result == "error") {
                self.setState({
                  showLoader: false,
                  errorMessage: response.data.message,
                  showAlert: true,
                });
                // alert(response.data.message);
                actions.setSubmitting(false);
                actions.setErrors(response.data.message);
              } else {
                self.setState({ showLoader: false });
                // alert("Mail sent to Reset Password");
                // self.setState({ redirect: true });
                self.setState({
                  messsagePopup: true,
                  popupContent: "Mail sent to Reset Password",
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="loginMainPage" style={{ backgroundImage: `url("/img/loginBackground.jpg")` }}>
                <Form autoComplete="off">
                  <div className="text-center">
                    <Link to={`/`} className="">
                      <img src="/img/logo.png" className="logoImg" />
                    </Link>
                    <p className="tagLine text-center">
                      TAKE CONTROL OF YOUR REAL ESTATE
                    </p>
                    <Alert
                      variant="danger"
                      onClose={() => this.setState({ showAlert: false })}
                      dismissible
                      show={this.state.showAlert}
                    >
                      <Alert.Heading>
                        {this.state.errorMessage}
                      </Alert.Heading>
                    </Alert>
                  </div>
                  <div>
                    <div className="formInner mb-4">
                      <label >
                        Email <span>*</span>
                      </label>
                      <div className="position-relative">
                        <Field type="text" name="email" />

                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <Link to={`/`} className="btnLink">
                      Login
                    </Link>
                    <div className="formInner">
                      {this.state.showLoader && (
                        <p
                          className="text-center mb-0"
                          style={{ fontWeight: "600" }}
                        >
                          <img src="/img/loading.gif" width={"80px"} />
                        </p>
                      )}
                      <button
                        type="submit"
                        className="loginBtn"
                        value="LOGIN"
                        onClick={(e) => {
                          this.setState({ showAlert: false });
                        }}
                      >
                        Forgot Password
                      </button>
                    </div>
                  </div>
                  <div className="madeByPart mt-5 text-center">
                    <p className="">Made By</p>
                    <p className="marginBottom-0">
                      <img src="/img/cre-matrix-logo.png" />
                    </p>
                  </div>
                </Form>
              </div>

              {/* <div className="unitFormContainer login">
                <div className="container">
                  <div className="row"></div>
                </div>
                <div>
                  <div></div>
                </div>
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-5 mx-auto">
                        <div className="formContainer">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <h1 className="text-center">
                              <Link to={`/lease-summary`} className="">
                                <img src="/img/logo.png" className="logoImg" />
                              </Link>
                            </h1>
                            <p className="tagLine text-center">
                              TAKE CONTROL OF YOUR REAL ESTATE
                            </p>
                            <Alert
                              variant="danger"
                              onClose={() => this.setState({ showAlert: false })}
                              dismissible
                              show={this.state.showAlert}
                            >
                              <Alert.Heading>
                                {this.state.errorMessage}
                              </Alert.Heading>
                            </Alert>
                          </div>
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-12 col-form-label">
                                Email <span>*</span>
                              </label>
                              <div className="col-sm-12">
                                <Field type="text" name="email" />

                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="inputContainer col-lg-12 col-md-12 marginBottom-0">
                            <div className="row">
                              <div className="col-sm-12">


                                {this.state.showLoader && (
                                  <p
                                    className="text-center mb-0"
                                    style={{ fontWeight: "600" }}
                                  >
                                    <img src="/img/loading.gif" width={"80px"} />
                                  </p>
                                )}
                                <button
                                  type="submit"
                                  className="loginBtn"
                                  value="LOGIN"
                                  onClick={(e) => {
                                    this.setState({ showAlert: false });
                                  }}
                                >
                                  Forgot Password
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="inputContainer col-lg-12 col-md-12 mt-4 madeBy marginBottom-0">
                            <div className="row">
                              <div className="col-sm-12 text-center">
                                <p>Made By</p>
                                <p className="marginBottom-0">
                                  <img src="/img/cre-matrix-logo.png" />
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </div>
    );
  }
}

export default UserForgotPassword;
